import styled from 'styled-components';

const FormStyled = styled.div`
.form-input {
    margin-bottom: 0px;
}
`;

export default FormStyled;
